module.exports = __webpack_public_path__ + "static/media/ch1.d44bd9ee.png";